import StorageFormSummary from '../StorageForm/components/StorageFormSummary/StorageFormSummary';
import { useNavigate } from 'react-router-dom';
import styles from '../Storage/storage.module.css';
import { useState } from 'react';
import axios from '../../../utils/axios';

const StoragePreview = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    const [preview] = useState(sessionStorage.getItem('storagePreview'));

    if (!preview) {
        navigate('/workflows', { replace: true });
    }

    const handleClose = () => {
        navigate(-1);
    };

    const handleSubmit = () => async () => {
        setLoading(true);

        try {
            const res = await axios.post(`/workflows/storage`, JSON.parse(preview!));

            // if (!res.data) return;
            sessionStorage.removeItem('storagePreview');

            // navigate(`/storage/${res.data.id}`);
            navigate(`/dashboard?t=storage`);
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.page}>
            <StorageFormSummary
                selectedData={JSON.parse(preview!)}
                handleClose={handleClose}
                handleSubmit={handleSubmit}
                loading={loading}
            />
        </div>
    );
};

export default StoragePreview;
